import * as React from 'react';

function SvgAfterpayColourSquare(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.344 8.458l-3.342-2.013-3.343-2.013c-2.228-1.258-5.075.377-5.075 3.02v.503c0 .251.124.503.371.629l1.61.88c.495.252.99-.126.99-.629V7.83c0-.504.495-.881.99-.63l3.095 1.762 2.97 1.887c.496.252.496.88 0 1.132l-3.094 1.762-3.094 2.013c-.496.251-.99-.126-.99-.63v-.503c0-2.642-2.848-4.277-5.076-3.019l-3.343 2.013-3.342 2.013c-2.228 1.258-2.228 4.655 0 5.913l3.342 2.013 3.343 2.013c2.228 1.258 5.075-.378 5.075-3.02v-.503a.693.693 0 00-.371-.629l-1.61-.88c-.495-.252-.99.125-.99.628v1.007c0 .503-.495.88-.99.629l-3.095-1.761L6.28 19.15c-.495-.251-.495-.88 0-1.132l3.095-1.761 3.095-1.761c.495-.252.99.125.99.629v.503c0 2.642 2.847 4.277 5.076 3.02l3.342-2.014 3.342-2.013c2.352-1.51 2.352-4.78.124-6.164z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgAfterpayColourSquare;
